import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Instagram Reel logo icon component
 */
export const InstagramReelLogo: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.90486 0H17.0951C18.9913 0 20.7166 0.773437 21.9682 2.01562C23.2219 3.25977 24 4.97656 24 6.86328V17.1387C24 19.0215 23.2219 20.7363 21.9722 21.9805L21.9682 21.9844C20.7146 23.2285 18.9894 24 17.0971 24H6.90486C5.00671 24 3.27952 23.2266 2.02784 21.9844L1.98068 21.9316C0.758474 20.6934 0 18.998 0 17.1367V6.86328C0 4.97461 0.776159 3.25977 2.02784 2.01562C3.27952 0.771484 5.00475 0 6.90486 0ZM17.9813 6.05859L17.9951 6.08008H22.2394C22.0684 4.9707 21.5359 3.97461 20.7696 3.21094C19.8264 2.27344 18.5256 1.69141 17.0951 1.69141H15.3522L17.9813 6.05859ZM16.0183 6.08008L13.3755 1.69141H7.57884L10.2532 6.08008H16.0183ZM8.27444 6.08008L5.68855 1.83398C4.74341 2.06055 3.89651 2.54688 3.23039 3.21094C2.46406 3.97266 1.93352 4.9707 1.7606 6.08008H8.27444ZM22.2983 7.77148H1.70165V17.1387C1.70165 18.5391 2.26953 19.8145 3.18716 20.748L3.23039 20.7891C4.17357 21.7266 5.47634 22.3105 6.90486 22.3105H17.0951C18.5256 22.3105 19.8264 21.7285 20.7676 20.793L20.7716 20.7891C21.7128 19.8535 22.2983 18.5605 22.2983 17.1387V7.77148ZM10.0115 10.7324L15.2834 14.1406C15.3679 14.1953 15.4446 14.2656 15.5055 14.3516C15.7452 14.6973 15.6568 15.1719 15.309 15.4102L10.0586 18.4902C9.92697 18.5977 9.75798 18.6621 9.57131 18.6621C9.14688 18.6621 8.80301 18.3203 8.80301 17.8984V11.3574H8.80694C8.80694 11.207 8.85214 11.0547 8.94449 10.9219C9.18814 10.5762 9.66563 10.4922 10.0115 10.7324Z"
      fill="currentColor"
    />
  </svg>
);
